import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { MapNomenclatureContratDto, MapNomenclatureDto } from '../../models/tre-nomenclature-dto.model';

@Injectable({
  providedIn: 'root',
})
export class NomenclaturesService {

  private cacheData$: Observable<MapNomenclatureDto>;
  private cacheContratData$: Observable<MapNomenclatureContratDto>;

  constructor(private readonly http: HttpClient) {}

  get nomenclatures() {
    if (!this.cacheData$) {
      this.cacheData$ = this.getAllNomenclatureHabilitations().pipe(shareReplay(1));
    }
    return this.cacheData$;
  }

  get nomenclaturesContrats() {
    if (!this.cacheContratData$) {
      this.cacheContratData$ = this.getAllNomenclatureContrat().pipe(shareReplay(1));
    }
    return this.cacheContratData$;
  }

  private getAllNomenclatureHabilitations(): Observable<MapNomenclatureDto> {
    return this.http.get<MapNomenclatureDto>(`${environment.API_URL}habilitations/nomenclatures/getAll`);
  }

  private getAllNomenclatureContrat(): Observable<MapNomenclatureContratDto> {
    return this.http.get<MapNomenclatureContratDto>(`${environment.API_URL}contrats/nomenclatures/getAll`);
  }

}
